import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ShiftsBrowse from "@/pages/ShiftsBrowse";
import ShiftDetail from "@/pages/ShiftDetail";
import NewShift from "@/pages/NewShift";
import Ranking from "@/pages/Ranking";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MapView from "@/pages/MapView";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Profile from "@/pages/Profile";
import Portfolio from "@/pages/Portfolio";
import Messages from "@/pages/Messages";
import Layout from "@/components/Layout";
import AuthCallback from "@/pages/AuthCallback";
import CompleteProfile from "@/pages/CompleteProfile";
import Admin from "@/pages/Admin";
import History from "@/pages/History";

const ProtectedRoute = ({ children, role, allowPending }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-400">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Google users mid-onboarding must complete their profile before entering the app
  if (user.role === "pending" && !allowPending) return <Navigate to="/complete-profile" replace />;
  if (role && user.role !== role && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (allowPending) return children; // no Layout for onboarding screen
  return <Layout>{children}</Layout>;
};

function AppRoutes() {
  const location = useLocation();
  // Detect Google Auth callback (`#session_id=...`) synchronously during render.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if ((location.hash || "").includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/complete-profile" element={<ProtectedRoute allowPending><CompleteProfile /></ProtectedRoute>} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/sobre" element={<Portfolio />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/shifts" element={<ProtectedRoute><ShiftsBrowse /></ProtectedRoute>} />
      <Route path="/map" element={<ProtectedRoute><MapView /></ProtectedRoute>} />
      <Route path="/shifts/new" element={<ProtectedRoute role="comercio"><NewShift /></ProtectedRoute>} />
      <Route path="/shifts/:id" element={<ProtectedRoute><ShiftDetail /></ProtectedRoute>} />
      <Route path="/ranking" element={<ProtectedRoute><Ranking /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
      <Route path="/premium" element={<ProtectedRoute role="comercio"><Premium /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><Admin /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
